// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"_2-z","colorTextValue":"a3-z","swatches":"b3-z","collapseLink":"c3-z","isCollapsed":"d3-z","dropdown":"e3-z","disabled":"f3-z"};